import { render, staticRenderFns } from "./TsgAdmins.vue?vue&type=template&id=43c2523e"
import script from "./TsgAdmins.vue?vue&type=script&lang=js"
export * from "./TsgAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports